// extracted by mini-css-extract-plugin
export var fullWidthButton = "_g4-0";